import React, {useContext, useState} from 'react';
import {Button} from 'reactstrap';
import {SystemConfigCtx} from '@/contexts';
import {appHost, appBaseName} from '@/config';
import {blank} from '@/util';
import absgLogo from '@/assets/images/absg_logo.svg';
import styles from '@/views/Layout/b2b/index.module.css';
import Icon from '@/views/shared/Icon';

import {LocaleLink} from '@/routes';
import {useTranslation} from 'react-i18next';

const Header = () => {
  const {siteCode} = useContext(SystemConfigCtx);
  const {t: tr} = useTranslation();

  const [collapse, setCollapse] = useState(true);
  const handleToggle = () => {
    setCollapse(!collapse);
  };

  if (blank(siteCode)) {
    return null;
  }

  const angularObjectPath = `{"root_url": "${appHost}${appBaseName}/"}`;

  return (
    <>
      {(siteCode === 'afs' || siteCode === 'ipc') && (
        <angular-header config={angularObjectPath} />
      )}
      {siteCode === 'absg' && (
        <header className={styles.headerAbsg}>
          <div className={styles.logoWrapper}>
            <img alt='ABSG' src={absgLogo} className={styles.absgLogo} />
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='273'
              height='80'
              viewBox='0 0 273 80'
              fill='none'
            >
              <path
                d='M276 0C264.638 0 253.901 5.25 246.855 14.2438L206.515 65.7563C199.469 74.75 188.732 80 177.37 80H0V0H276Z'
                fill='#BA9658'
              />
              <path
                d='M273 -3C261.638 -3 250.901 2.25 243.855 11.2438L203.515 62.7563C196.469 71.75 185.732 77 174.37 77H-3V-3H273Z'
                fill='white'
              />
            </svg>
          </div>

          <div className={styles.menu}>
            <Button onClick={handleToggle}>
              <Icon icon='user' />
            </Button>
            <div
              className={styles.dropdown}
              style={{display: collapse ? 'none' : 'flex'}}
            >
              <LocaleLink
                to='/b2b/change_password'
                className={styles.menuBtn}
                onClick={handleToggle}
              >
                {tr('change_password_button')}
              </LocaleLink>
              <LocaleLink to='/logout' className={styles.menuBtn}>
                {tr('logout')}
              </LocaleLink>
            </div>
          </div>
        </header>
      )}
    </>
  );
};

export default Header;
